import countries from "i18n-iso-countries";

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
countries.registerLocale(require("i18n-iso-countries/langs/hu.json"));

export const getCountryName = (countryCode: string, locale: string): string => {
  return countries.getName(countryCode, locale);
};

export default getCountryName;
